
const getters = {
  nickname: state => state.user.nickname,
  // 登录用户昵称，非用户名
  realName: state => state.user.realName,
  // 当前登录用户关联运营商id集合（可查看运营商id集合）
  operatorIds: state => state.user.operatorIdList,
  // 当前登录用户的运营商id/集团id
  operatorId: state => state.user.operatorId,
  // 集团id集合
  groupIds: state => state.user.groupIdList,
  // 客户id集合
  customerIds: state => state.user.customerIdList,
  // 当前用户角色
  roles: state => state.user.roleIdList,
  // 当前用户后端返回的菜单权限
  permissions: state => state.user.permissions,
  // 动态匹配好的路由
  permission_routes: state => state.permission.routes,
  // 用户类型：超级管理员 || 管理员 || 运营商 || 虚拟运营商 || 集团 || 充电用户
  userType: state => state.user.userType,
  // 云平台名字
  platformName: state => state.user.platformName,
  // 跳转首页
  homePage: state => state.user.homePage,
  // 完整的用户信息，后期再加就不单独提取了
  userDetail: state => state.user.userDetail
}
export default getters



// WEBPACK FOOTER //
// ./src/vuex/getters.js